import { ContextMenu as BaseContextMenu } from '@base-ui/react/context-menu'
import { twMerge } from 'tailwind-merge'
import { listGroupLabel } from '../../../lib/list-styles'
import type { PartProps } from '../../../lib/part-props'

interface ContextMenuGroupLabelProps extends PartProps<BaseContextMenu.GroupLabel.Props> {
  className?: string
}

function ContextMenuGroupLabel({ className, children, ...props }: ContextMenuGroupLabelProps) {
  return (
    <BaseContextMenu.GroupLabel className={twMerge(listGroupLabel, className)} {...props}>
      {children}
    </BaseContextMenu.GroupLabel>
  )
}

export { ContextMenuGroupLabel }
